import { useState } from 'react';

export const useAccordionControl: () => [
    string | false,
    (index: number) => void,
] = () => {
    const [accordionToExpand, setAccordionToExpand] = useState<string | false>(
        false
    );

    const clickAccordionOfIndex: (index: number) => void = (index: number) =>
        setAccordionToExpand((prevValue) =>
            prevValue === `panel${index}` ? false : `panel${index}`
        );

    return [accordionToExpand, clickAccordionOfIndex];
};
